import { render } from "./DFormTextarea.vue?vue&type=template&id=15c80bf5"
import script from "./DFormTextarea.vue?vue&type=script&lang=js"
export * from "./DFormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__